import React, { useState } from "react";
import { Plus } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { faq } = content;

export const Faq = ({ items = faq.items, h2 = faq.h2, label = faq.label }) => {
  const [open, setOpen] = useState(0);
  return (
    <Section id="faq" testId="section-faq" className="has-lines overflow-hidden bg-[#f5f6f4]">
      <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
      <Container>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <Reveal>
            <Label>{label}</Label>
            <AccentH2 className="mt-6 font-bold text-[#1e2532]">{h2}</AccentH2>
          </Reveal>

          <div className="border-t border-[#c9cdc9]">
            {items.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="border-b border-[#c9cdc9]">
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-start justify-between gap-6 py-7 text-left"
                    aria-expanded={isOpen ? "true" : "false"}
                    aria-controls={`faq-panel-${i}`}
                  >
                    <h3 className="font-semibold text-[#1e2532]">{item.q}</h3>
                    <Plus
                      size={22}
                      className="mt-1 shrink-0 text-[#0f9d6e]"
                      style={{
                        transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                        transition: "transform .45s cubic-bezier(.22,1,.36,1)",
                      }}
                    />
                  </button>
                  <div
                    id={`faq-panel-${i}`}
                    data-testid={`faq-answer-${i}`}
                    className="faq-panel"
                    data-open={isOpen ? "true" : "false"}
                  >
                    <div>
                      <p className="max-w-[680px] pb-8 pr-10 text-[16.5px] leading-[1.8] text-[#565f70]">{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </Section>
  );
};
